import React from "react"

import { scopeCmsHtml } from "@utils/scope-cms-html"

const Banner = ({ banner }) => {
  const { startDate, endDate, showIndefinitely, html } = banner
  let showBanner = true

  if (!showIndefinitely) {
    try {
      const now = new Date().getTime()
      const start = new Date(startDate).getTime()
      const end = new Date(endDate).getTime()

      showBanner = now >= start && now < end
    } catch (err) {
      console.error("There was an issue comparing dates", err)
      showBanner = false
    }
  }

  if (!showBanner) {
    return null
  }

  const { scopedStyles, bodyHtml } = scopeCmsHtml(html || "", ".offer-banner")

  return (
    <div>
      {scopedStyles.trim() && (
        <style dangerouslySetInnerHTML={{ __html: scopedStyles }} />
      )}
      <div
        className="offer-banner"
        dangerouslySetInnerHTML={{ __html: bodyHtml }}
      />
    </div>
  )
}

export default Banner
